import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UsingMode, ModerationStatus, CommentPack, UserComment } from "../../core/review";
import { StorageService } from "../../storage.service";
import { User } from "../../core/user";

@Component({
    selector: 'comment',
    templateUrl: './comment.component.html',
    styleUrls: ['./style.scss', './comment.component.scss'],
})
export class CommentComponent implements OnInit {
    @Input() value: CommentPack;
    @Input() user: User;
    @Output() commentRemoving = new EventEmitter<CommentPack>();

    ModerationStatus = ModerationStatus;
    UsingMode = UsingMode;

    mode: UsingMode = UsingMode.User;
    isGodCommentOpened: boolean = false;

    constructor(private storage: StorageService) {
        storage.isSensitiveDataExist.subscribe(v => { this.init(v); });
    }

    ngOnInit() {
        this.init(this.storage.isSensitiveDataExist.value);
    }

    toggle(isOpened) {
        this.isGodCommentOpened = isOpened;
    }

    onDeleteConfirmationClosed(e) {
        if (e && e.needToDelete === true) {
            this.commentRemoving.emit(this.value);
        }
    }

    onReviewFormClosed(comment: UserComment) {
        if (comment) {
            this.value.comment.message = comment.message;
        }
    }

    private init(isSensitiveDataExist: boolean) {
        if (isSensitiveDataExist && this.user) {
            if (this.user && this.user.isModerator) {
                this.mode = UsingMode.God;
            } else {
                this.mode = UsingMode.User;
            }
        } else {
            this.mode = UsingMode.Anonymous;
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/review/comment.component.ts